import { API_BASE } from '@/content';

const TOKEN_KEY = 'gz_editor_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function login(email: string, password: string): Promise<string> {
  const res = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Anmeldung fehlgeschlagen.');
  }
  const data = await res.json();
  return data.token as string;
}

export async function fetchContent(): Promise<Record<string, unknown>> {
  const res = await fetch(`${API_BASE}/content`);
  if (!res.ok) throw new Error('Inhalte konnten nicht geladen werden.');
  const data = await res.json();
  return (data.content || {}) as Record<string, unknown>;
}

export async function saveContent(content: unknown): Promise<void> {
  const res = await fetch(`${API_BASE}/content`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken() ?? ''}`,
    },
    body: JSON.stringify({ content }),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Speichern fehlgeschlagen.');
  }
}

export async function forgotPassword(): Promise<string | undefined> {
  const res = await fetch(`${API_BASE}/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'E-Mail konnte nicht gesendet werden.');
  }
  const data = await res.json().catch(() => ({}));
  return data.sentTo as string | undefined;
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  const res = await fetch(`${API_BASE}/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Passwort konnte nicht zurückgesetzt werden.');
  }
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  const res = await fetch(`${API_BASE}/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken() ?? ''}`,
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Passwort konnte nicht geändert werden.');
  }
}
